module.exports = __webpack_public_path__ + "static/img/can-orange.6df7d43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-orange.png
// module id = nR6h
// module chunks = 0